import React, { useEffect, useState } from "react";
import ReactModal from "../../../../Components/Modal/Modal";
import CheckIn from "../../../../Asssets/Images/checkIn.svg";
import { Box } from "@mui/system";
import { Button, InputLabel, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { updateMyCheckInRemarks } from "../../../../Redux/Actions/Attendance";
import { Spinner } from "react-bootstrap";

const REMARKS_MAX = 200;

const EditCheckInRemarksModal = ({ classes, modalOpen, setModalOpen }) => {
  const dispatch = useDispatch();
  const [remarks, setRemarks] = useState("");
  const [saving, setSaving] = useState(false);
  const { attendance: lastAttendance } = useSelector((state) => state.lastAttendance);

  useEffect(() => {
    if (!modalOpen) return;
    const current = lastAttendance?.attendance?.check_in_remarks;
    setRemarks(typeof current === "string" ? current : "");
  }, [modalOpen, lastAttendance?.attendance?.check_in_remarks]);

  const handleSave = () => {
    setSaving(true);
    dispatch(updateMyCheckInRemarks(remarks))
      .then((result) => {
        setSaving(false);
        if (result?.success) {
          setModalOpen(false);
        }
      })
      .catch(() => setSaving(false));
  };

  return (
    <ReactModal open={modalOpen} setOpen={setModalOpen}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          src={CheckIn}
          alt=""
          style={{ width: "90px", height: "90px", marginTop: "-34px" }}
        />
        <Box sx={{ my: 1, width: "95%" }}>
          <InputLabel className={classes.department_label}>
            Edit check-in remarks
          </InputLabel>
          <TextField
            sx={{ mt: 1 }}
            placeholder={`Remarks ${REMARKS_MAX} characters (max)`}
            fullWidth
            className={classes.inputContainer}
            rows={3}
            multiline
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            inputProps={{ maxLength: REMARKS_MAX }}
          />
          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 4 }}
            type="button"
            className={classes.createBtn}
            disabled={saving}
            onClick={handleSave}
          >
            {saving ? <Spinner size="sm" animation="border" /> : "Save remarks"}
          </Button>
        </Box>
      </Box>
    </ReactModal>
  );
};

export default EditCheckInRemarksModal;
